import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es';
import en from './locales/en';
import pt from './locales/pt';
import fr from './locales/fr';
import de from './locales/de';
import nl from './locales/nl';
import ro from './locales/ro';
import { SUPPORTED_LANGUAGE_CODES } from './languages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
      fr: { translation: fr },
      de: { translation: de },
      nl: { translation: nl },
      ro: { translation: ro },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
